import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Update } from '@ngrx/entity';
import { InvoiceDetail, NewInvoiceDetail } from '@portal-front-end/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_SERVER_TOKEN } from '../api-server-token';

@Injectable({ providedIn: 'root' })

export class InvoiceDetailApiService {

    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly READ_INVOICE_DETAIL_API_URL = `${this.apiServer}/invoicing-detail-view`;
    private readonly INVOICE_DETAIL_API_URL = `${this.apiServer}/invoicing-detail`;

    getInvoiceDetails(invoiceId: string): Observable<InvoiceDetail[]> {
        return this.http.get<InvoiceDetail[]>(`${this.READ_INVOICE_DETAIL_API_URL}`,{
            params: {
                'invoiceId' : invoiceId
            }
        })
        .pipe(map(invoiceDetails => {
            return invoiceDetails.map(this.calculateAdditionalFields)
        }));
    }

    updateInvoiceDetail(product: Update<InvoiceDetail>): Observable<InvoiceDetail> {
        return this.http.put<InvoiceDetail>(`${this.INVOICE_DETAIL_API_URL}/${product.changes.invoiceDetailId}`, product.changes)
        .pipe(map(this.calculateAdditionalFields));
    }

    deleteInvoiceDetail(id: string | number): Observable<string | number>{
        return this.http.delete<string | number>(`${this.INVOICE_DETAIL_API_URL}/${id}`)
            .pipe(map(() => id));
    }

    insertInvoiceDetail(invoiceDetail: NewInvoiceDetail): Observable<InvoiceDetail> {
        return this.http.post<InvoiceDetail>(this.INVOICE_DETAIL_API_URL, invoiceDetail)
        .pipe(map(this.calculateAdditionalFields));
    }

    private calculateAdditionalFields(id :InvoiceDetail) : InvoiceDetail{
        const invoiceCost = +(id.receiveQuantity * id.receiveUnit * ( id.receiveCost / id.receiveCostUnit )).toFixed(2);
        let systemCost = null;
        let variance = null;
        if(id.cartonCost != undefined && id.cartonQuantity != undefined){
            systemCost = +(id.receiveQuantity * id.receiveUnit * ( id.cartonCost / id.cartonQuantity )).toFixed(2);
            variance = +(invoiceCost - systemCost).toFixed(2);
        }
        return {
            ...id,
            description: id.description || "",
            quantity: id.receiveQuantity,   // assume carton mode - round off to 4 digits
            invoiceCost,
            systemCost,
            variance,
            orderCode: id.productOrganisationId ? id.orderCode : "PRODUCT NOT FOUND"
        };
    }
}